import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames/bind';
import { PopupTooltip } from '../../overlays';
import { ColorHash } from '../../../utils';
import styles from './styles.scss';
const cx = classnames.bind(styles);
const colorHash = new ColorHash();
const InitialsAvatar = ({ initials, size = 'medium', backgroundColor, identifier, tooltipContent, onClick, className, }) => {
    const avatarClasses = cx('initials-avatar', size, { clickable: !!onClick }, className);
    const avatarStyle = {
        backgroundColor: backgroundColor || (identifier ? colorHash.hex(identifier) : '#6c757d'),
        cursor: onClick ? 'pointer' : 'default',
    };
    const avatar = (_jsx("div", { className: avatarClasses, style: avatarStyle, "aria-label": tooltipContent ? `Avatar for ${initials}` : initials, "data-elm-id": `initials-avatar-${initials}`, onClick: onClick, role: onClick ? 'button' : undefined, tabIndex: onClick ? 0 : undefined, children: initials }));
    return tooltipContent ? (_jsx(PopupTooltip, { trigger: avatar, position: 'top center', hoverable: true, hideOnScroll: true, children: _jsx("div", { className: cx('tooltip-content'), children: tooltipContent }) })) : (avatar);
};
export default InitialsAvatar;
//# sourceMappingURL=index.js.map